import React from 'react';
import PropTypes from 'prop-types';

import {
  Wrapper,
  Header,
  StepBadge,
  Title,
  Divider,
  Body
} from './styled';

const StepContainer = ({
  title,
  stepNumber,
  children,
  className
}) => {
  return (
    <Wrapper className={ className }>
      <Header>
        <StepBadge>{stepNumber}</StepBadge>
        <Title>{title}</Title>
      </Header>
      <Divider />
      <Body>
        {children}
      </Body>
    </Wrapper>
  );
};

StepContainer.propTypes = {
  title: PropTypes.string.isRequired,
  stepNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  children: PropTypes.node,
  className: PropTypes.string
};

StepContainer.defaultProps = {
  children: null,
  className: ''
};

export default StepContainer;
